import React from 'react';
import { colors, typography } from '../../../styles/theme';
import { FILTER_ACCENT, FILTER_ACCENT_CONTRAST } from './FilterPanel.styles';

const rowStyle = {
  display: 'flex',
  gap: '4px',
  padding: '3px',
  borderRadius: '6px',
  backgroundColor: 'rgba(255,255,255,0.06)',
  border: `1px solid ${colors.border}`,
  width: '100%',
};

const btnStyle = ({ active = false, disabled = false } = {}) => ({
  flex: 1,
  height: '32px',
  border: 'none',
  borderRadius: '4px',
  backgroundColor: active ? FILTER_ACCENT : 'transparent',
  color: active ? FILTER_ACCENT_CONTRAST : colors.textSecondary,
  fontSize: typography.fontSize.xs,
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.medium,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.6 : 1,
  whiteSpace: 'nowrap',
  padding: '0 4px',
});

/**
 * Control segmentado de 3 estados (Todos / Sí / No).
 * @param {string} [title] tooltip nativo; se usa para explicar el estado deshabilitado
 */
function FilterSegmentedControl({
  options,
  value,
  onChange,
  disabled = false,
  title,
}) {
  return (
    <div style={rowStyle} role="group" title={title}>
      {options.map((opt) => {
        const active = value === opt.value || (opt.value == null && value == null);
        return (
          <button
            key={opt.key}
            type="button"
            style={btnStyle({ active, disabled })}
            aria-pressed={active}
            disabled={disabled}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default FilterSegmentedControl;
